import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const MachineLearningPage: React.FC = () => {
  return <ServicePageTemplate slug="machine-learning" />;
};

export default MachineLearningPage;
